import { Injectable, OnDestroy } from '@angular/core';

declare let Plotly: any;

@Injectable({ providedIn: 'root' })
export class PlotlyService implements OnDestroy {

  create(divId: string, data: any[], layout: any, config: any = {}) {
    return Plotly.newPlot(divId, data, layout, config);
  }

  update(divId: string, data: any[], layout: any) {
    return Plotly.react(divId, data, layout);
  }

  resize(divId: string) {
    return Plotly.Plots.resize(divId);
  }

  destroy(divId: string) {
    Plotly.purge(divId);
  }

  ngOnDestroy() {}
}
